import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Section from './Section';
import SectionColumn from './SectionColumn';

const styles = () => ({
  root: {},
});

const PerformanceSection = ({
  performance,
  benchmark,
  showBenchmark,
}) => {
  return (
    <Section>
      <SectionColumn header={'Your Portfolio'} value={`${performance}%`} />
      {showBenchmark && <SectionColumn header={'Benchmark'} value={`${benchmark}%`} />}
    </Section>
  );
};

PerformanceSection.defaultProps = {
  showBenchmark: true,
};

PerformanceSection.propTypes = {
  performance: PropTypes.string.isRequired,
  benchmark: PropTypes.string.isRequired,
  showBenchmark: PropTypes.bool,
};

export default withStyles(styles)(PerformanceSection);
